<!--
 * @Author       : Bruce
 * @Date         : 2025-03-24 10:31:06
 * @LastEditors  : Bruce
 * @LastEditTime : 2025-04-30 17:49:57
 * @LastEditTime : 2025-04-24 19:06:40
 * @FilePath     : /app/javascript/dashboard/routes/dashboard/settings/inbox/WidgetBuilder.vue
 * @Description  :
											http://127.0.0.1:3000/app/accounts/1/settings/inboxes/8
										收件箱设置: 小元件建立器
 * Copyright 2025 Bruce, All Rights Reserved.
 * 2025-03-24 10:31:06
-->
<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import Widget from 'dashboard/modules/widget-preview/components/Widget.vue';
import InputRadioGroup from './components/InputRadioGroup.vue';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';

export default {
  components: {
    Widget,
    InputRadioGroup,
  },
  props: {
    inbox: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      isWidgetPreview: true,
      color: '#1f93ff',
      websiteName: '',
      welcomeHeading: '',
      welcomeTagline: '',
      replyTime: 'in_a_few_minutes',
      avatarFile: null,
      avatarUrl: '',
      widgetBubblePosition: 'right',
      widgetBubbleDrag: false,
      widgetBubbleLauncherTitle: this.$t(
        'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.DEFAULT'
      ),
      widgetBubbleType: 'standard',
      useBrowserLanguage: false,
      skipHomeScreen: false,
      widgetLanguage: 'site', // 默认跟随站点语言
      widgetBubblePositions: [
        {
          id: 'left',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.LEFT'
          ),
          checked: false,
        },
        {
          id: 'right',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.RIGHT'
          ),
          checked: true,
        },
      ],
      widgetBubbleDragOptions: [
        {
          id: 'enabled',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.ENABLE_BUBBLE_DRAG.ENABLED'
          ),
          checked: false,
        },
        {
          id: 'disabled',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.ENABLE_BUBBLE_DRAG.DISABLED'
          ),
          checked: true,
        },
      ],
      widgetBubbleTypes: [
        {
          id: 'standard',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_TYPE.STANDARD'
          ),
          checked: true,
        },
        {
          id: 'expanded_bubble',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_TYPE.EXPANDED_BUBBLE'
          ),
          checked: false,
        },
      ],
      showBranding: true,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    storageKey() {
      return `${LOCAL_STORAGE_KEYS.WIDGET_BUILDER}${this.inbox.id}`;
    },
    widgetScript() {
      // let options = {
      //   position: this.widgetBubblePosition,
      //   type: this.widgetBubbleType,
      //   launcherTitle: this.widgetBubbleLauncherTitle,
      // };
      // let script = this.inbox.web_widget_script;
      // return (
      //   script.substring(0, 13) +
      //   this.$t('INBOX_MGMT.WIDGET_BUILDER.SCRIPT_SETTINGS', {
      //     options: JSON.stringify(options),
      //   }) +
      //   script.substring(13)
      // );
      // TODO: 生成脚本, 去掉 settings 的配置代码
      return this.inbox.web_widget_script;
    },
    getWidgetViewOptions() {
      return [
        {
          id: 'preview',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_VIEW_OPTION.PREVIEW'
          ),
          checked: true,
        },
        {
          id: 'script',
          title: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_VIEW_OPTION.SCRIPT'
          ),
          checked: false,
        },
      ];
    },
    getReplyTimeOptions() {
      return [
        {
          key: 'in_a_few_minutes',
          value: 'in_a_few_minutes',
          text: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.REPLY_TIME.IN_A_FEW_MINUTES'
          ),
        },
        {
          key: 'in_a_few_hours',
          value: 'in_a_few_hours',
          text: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.REPLY_TIME.IN_A_FEW_HOURS'
          ),
        },
        {
          key: 'in_a_day',
          value: 'in_a_day',
          text: this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.REPLY_TIME.IN_A_DAY'
          ),
        },
      ];
    },
    websiteNameValidationErrorMsg() {
      return this.v$.websiteName.$error
        ? this.$t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WEBSITE_NAME.ERROR')
        : '';
    },
    messageLink() {
      const baseUrl = window.location.origin;
      return `${baseUrl}/widget?website_token=${this.inbox.website_token}`;
    },
    copyMessageLink() {
      navigator.clipboard.writeText(this.messageLink);
      useAlert(
        this.$t(
          'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.MESSAGE_LINK.COPY_SUCCESS'
        )
      );
    },
  },
  mounted() {
    this.setDefaults();
  },
  validations: {
    websiteName: { required },
  },
  methods: {
    downloadChatHtml() {
      const { id } = this.inbox;
      this.$store.dispatch('inboxes/downloadChatHtml', {
        inboxId: id,
        fileName: 'chat.html',
      });
    },
    setDefaults() {
      // Widget Settings
      const {
        name,
        welcome_title,
        welcome_tagline,
        widget_color,
        reply_time,
        avatar_url,
        use_browser_language,
        bubble_drag,
        bubble_type,
        launcher_title,
        widget_language,
        show_branding,
        skip_home_screen,
      } = this.inbox;
      this.websiteName = name;
      this.welcomeHeading = welcome_title;
      this.welcomeTagline = welcome_tagline;
      this.color = widget_color;
      this.replyTime = reply_time;
      this.avatarUrl = avatar_url;
      this.useBrowserLanguage = use_browser_language || false;
      // 旧版语言 bool 判断转换为字符串：'browser' -跟随浏览器 : 'site' - 跟随站点语言
      const browserLanguageString = use_browser_language ? 'browser' : 'site';
      // 优先使用新的 widget_language，如果没有则根据旧的 use_browser_language 推断
      this.widgetLanguage = widget_language || browserLanguageString;
      this.widgetBubbleDrag = bubble_drag === true;
      this.widgetBubbleType = bubble_type || 'standard';
      this.widgetBubbleLauncherTitle =
        launcher_title ||
        this.$t(
          'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.DEFAULT'
        );

      this.showBranding = show_branding !== false;
      this.skipHomeScreen = skip_home_screen === true;
      this.widgetBubbleDragOptions = this.widgetBubbleDragOptions.map(item => {
        item.checked =
          item.id === 'enabled'
            ? this.widgetBubbleDrag
            : !this.widgetBubbleDrag;
        return item;
      });

      this.widgetBubbleTypes = this.widgetBubbleTypes.map(item => {
        item.checked = item.id === this.widgetBubbleType;
        return item;
      });
    },
    handleWidgetBubblePositionChange(item) {
      this.widgetBubblePosition = item.id;
    },
    handleWidgetBubbleDragChange(item) {
      this.widgetBubbleDrag = item.id === 'enabled';
      this.widgetBubbleDragOptions = this.widgetBubbleDragOptions.map(opt => {
        opt.checked = opt.id === item.id;
        return opt;
      });
    },
    handleWidgetBubbleTypeChange(item) {
      this.widgetBubbleType = item.id;
      this.widgetBubbleTypes = this.widgetBubbleTypes.map(opt => {
        opt.checked = opt.id === item.id;
        return opt;
      });
    },
    handleWidgetViewChange(item) {
      this.isWidgetPreview = item.id === 'preview';
    },
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarUrl = url;
    },
    async handleAvatarDelete() {
      try {
        await this.$store.dispatch('inboxes/deleteInboxAvatar', this.inbox.id);
        this.avatarFile = null;
        this.avatarUrl = '';
        useAlert(
          this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.AVATAR.DELETE.API.SUCCESS_MESSAGE'
          )
        );
      } catch (error) {
        useAlert(
          error.message
            ? error.message
            : this.$t(
                'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.AVATAR.DELETE.API.ERROR_MESSAGE'
              )
        );
      }
    },
    async updateWidget() {
      try {
        const payload = {
          id: this.inbox.id,
          name: this.websiteName,
          channel: {
            widget_color: this.color,
            welcome_title: this.welcomeHeading,
            welcome_tagline: this.welcomeTagline,
            reply_time: this.replyTime,
            widget_position: this.widgetBubblePosition,
            bubble_type: this.widgetBubbleType,
            bubble_drag: this.widgetBubbleDrag,
            launcher_title: this.widgetBubbleLauncherTitle,
            use_browser_language: this.useBrowserLanguage,
            widget_language: this.widgetLanguage, // 将语言字符串通过 api -> web_widget.rb -> 保存到 other_set
            show_branding: this.showBranding,
            skip_home_screen: this.skipHomeScreen,
          },
        };
        if (this.avatarFile) {
          payload.avatar = this.avatarFile;
        }
        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(
          this.$t(
            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.UPDATE.API.SUCCESS_MESSAGE'
          )
        );
      } catch (error) {
        useAlert(
          error.message ||
            this.$t(
              'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.UPDATE.API.ERROR_MESSAGE'
            )
        );
      }
    },
  },
};
</script>

<template>
  <div class="mx-6">
    <div class="flex p-2.5">
      <div class="w-100 lg:w-[40%]">
        <div class="min-h-full py-4 pr-2 overflow-y-scroll">
          <form @submit.prevent="updateWidget">
            <woot-avatar-uploader
              :label="
                $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.AVATAR.LABEL')
              "
              :src="avatarUrl"
              delete-avatar
              @on-avatar-select="handleImageUpload"
              @on-avatar-delete="handleAvatarDelete"
            />
            <woot-input
              v-model="websiteName"
              :class="{ error: v$.websiteName.$error }"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WEBSITE_NAME.LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WEBSITE_NAME.PLACE_HOLDER'
                )
              "
              :error="websiteNameValidationErrorMsg"
              @blur="v$.websiteName.$touch"
            />
            <woot-input
              v-model="welcomeHeading"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WELCOME_HEADING.LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WELCOME_HEADING.PLACE_HOLDER'
                )
              "
            />
            <woot-input
              v-model="welcomeTagline"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WELCOME_TAGLINE.LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WELCOME_TAGLINE.PLACE_HOLDER'
                )
              "
            />
            <label>
              {{
                $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.REPLY_TIME.LABEL')
              }}
              <select v-model="replyTime">
                <option
                  v-for="option in getReplyTimeOptions"
                  :key="option.key"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </label>
            <!-- 小部件语言设置新增多语言选项 -->
            <label>
              {{
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.LANGUAGE_SETTING.LABEL'
                )
              }}
              <select v-model="widgetLanguage">
                <option value="browser">
                  {{
                    $t(
                      'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.LANGUAGE_SETTING.BROWSER'
                    )
                  }}
                </option>
                <option value="site">
                  {{
                    $t(
                      'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.LANGUAGE_SETTING.SITE'
                    )
                  }}
                </option>
                <option value="en">English (en)</option>
                <option value="zh_TW">中文(台湾) (zh-TW)</option>
                <option value="ja">日本語 (ja)</option>
                <option value="ko">한국어 (ko)</option>
                <option value="ar">العربية (ar)</option>
                <option value="vi">Tiếng Việt (vi)</option>
                <option value="pt_BR">Português Brasileiro (pt-BR)</option>
              </select>
            </label>
            <label>
              {{
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_COLOR_LABEL'
                )
              }}
              <woot-color-picker v-model="color" />
            </label>
            <!-- <InputRadioGroup
              name="widget-bubble-position"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION_LABEL'
                )
              "
              :items="widgetBubblePositions"
              :action="handleWidgetBubblePositionChange"
            /> -->
            <!-- enableBubbleDrag 是否可拖拽 -->
            <InputRadioGroup
              name="enable-bubble-drag"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.ENABLE_BUBBLE_DRAG_LABEL'
                )
              "
              :items="widgetBubbleDragOptions"
              :action="handleWidgetBubbleDragChange"
            />
            <InputRadioGroup
              name="widget-bubble-type"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_TYPE_LABEL'
                )
              "
              :items="widgetBubbleTypes"
              :action="handleWidgetBubbleTypeChange"
            />
            <woot-input
              v-model="widgetBubbleLauncherTitle"
              :label="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.PLACE_HOLDER'
                )
              "
            />
            <label>
              {{ $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.SHOW_BRANDING') }}
            </label>
            <div class="flex items-center gap-3 mb-6">
              <woot-switch v-model="showBranding" />
              <span class="text-xs text-slate-500 dark:text-slate-400">
                {{
                  $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.BRANDING_DESC')
                }}
              </span>
            </div>
            <label>
              {{
                $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.SKIP_HOME_SCREEN')
              }}
            </label>
            <div class="flex items-center gap-3 mb-6">
              <woot-switch v-model="skipHomeScreen" />
              <span class="text-xs text-slate-500 dark:text-slate-400">
                {{
                  $t(
                    'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.SKIP_HOME_SCREEN_DESC'
                  )
                }}
              </span>
            </div>
            <woot-submit-button
              class="mt-4"
              :button-text="
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.UPDATE.BUTTON_TEXT'
                )
              "
              :loading="uiFlags.isUpdating"
              :disabled="v$.$invalid || uiFlags.isUpdating"
            />
          </form>
        </div>
      </div>
      <div class="w-100 lg:w-3/5">
        <InputRadioGroup
          name="widget-view-options"
          class="text-center"
          :items="getWidgetViewOptions"
          :action="handleWidgetViewChange"
        />
        <div
          v-if="isWidgetPreview"
          class="flex flex-col items-center justify-end min-h-[40.625rem] mx-5 mb-5 p-2.5 bg-slate-50 dark:bg-slate-900/50 rounded-lg"
        >
          <!-- 小部件预览显示入口_001 -->
          <Widget
            :welcome-heading="welcomeHeading"
            :welcome-tagline="welcomeTagline"
            :website-name="websiteName"
            :logo="avatarUrl"
            is-online
            :reply-time="replyTime"
            :color="color"
            :widget-bubble-position="widgetBubblePosition"
            :widget-bubble-launcher-title="widgetBubbleLauncherTitle"
            :widget-bubble-type="widgetBubbleType"
            :show-branding="showBranding"
          />
        </div>
        <div v-else class="mx-5">
          <div class="mb-4 p-2.5 bg-slate-50 rounded-lg dark:bg-slate-700">
            <h3
              class="mb-2 text-sm font-medium text-slate-700 dark:text-slate-200"
            >
              {{
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_VIEW_OPTION.WIDGET'
                )
              }}
            </h3>
            <woot-code :script="widgetScript" />
          </div>
          <div class="mb-4 p-2.5 bg-slate-50 rounded-lg dark:bg-slate-700">
            <h3
              class="mb-2 text-sm font-medium text-slate-700 dark:text-slate-200"
            >
              {{
                $t(
                  'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_VIEW_OPTION.LINK'
                )
              }}
            </h3>
            <woot-code :script="messageLink" />
          </div>

          <div class="p-2.5 bg-slate-50 rounded-lg dark:bg-slate-700">
            <div class="flex items-center justify-between">
              <h3
                class="text-sm font-medium text-slate-700 dark:text-slate-200"
              >
                {{
                  $t('INBOX_MGMT.SETTINGS_POPUP.DOWNLOAD_CHAT_HTML_SUBTITLE')
                }}
              </h3>
              <woot-button
                variant="primary"
                size="small"
                icon="download"
                @click="downloadChatHtml"
              >
                {{ $t('INBOX_MGMT.SETTINGS_POPUP.DOWNLOAD_CHAT_HTML_LINK') }}
              </woot-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
